import { getHeaders, getNonJsonHeaders, getNoAuthHeaders } from '../../../core/api';
import { host } from '../../../config';

export function fetchHotel(id) {
  return fetch(`${host}/api/property/hotel/${id}/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchHotels() {
  return fetch(`${host}/api/property/hotel/?managed=true`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchHotelsSearch(search, hasSearchPrefs) {
  if(hasSearchPrefs) {
    let searchText = search.searchText;
    let starsUpper = search.stars.upper;
    let starsLower = search.stars.lower;
    let brands = search.brands;
    let brandsStr = ''
    let getUrl = `${host}/api/property/hotel/?hasSearchPrefs=${hasSearchPrefs}&search=${searchText}&stars_upper=${starsUpper}&stars_lower=${starsLower}&brands=${brands}`; 
    if(brands.length > 1) {
      brands.forEach((brand)=>{
        brandsStr = brandsStr + `&brands=${brand}`
      })
      getUrl = `${host}/api/property/hotel/?hasSearchPrefs=${hasSearchPrefs}&search=${searchText}&stars_upper=${starsUpper}&stars_lower=${starsLower}${brandsStr}`; 
    }
    
    return fetch(getUrl, {
      headers: getHeaders(),
      method: 'GET',
    });
  }
  return fetch(`${host}/api/property/hotel/?search=${search}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchHotelsAdvanceSearch(search) {
  return fetch(`${host}/api/property/hotel/advance_search/?advanceSearch=${search}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchHotelsAdvanceSearchWithPrefs(payload) {
  let eventId = payload.eventId;
  let searchTerm = payload.searchTerm;
  return fetch(`${host}/api/property/hotel/advance_search_with_prefs/?event=${eventId}&searchTerm=${searchTerm}`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchHotelsbyplace(payload){
  return fetch(`${host}/api/gethotels/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchSuggestedHotels() {
  return fetch(`${host}/api/property/hotel/suggested/`, {
    headers: getHeaders(),
    method: 'GET',
    
  });
}
export function postPropertyAccount(payload) {
  if (payload.email) {
    // Send non-authorized request when registering
    return fetch(`${host}/api/property/register/`, {
      headers: getNoAuthHeaders(),
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }
  return fetch(`${host}/api/property/register/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function patchHotel(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function postHotel(payload) {
  //debugger;
  return fetch(`${host}/api/property/hotel/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postAddPositionHotel(id,payload) {
  return fetch(`${host}/api/property/hotel/${id}/add_hotel/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postHotelFeatures(id, payload) {
  //debugger;
  //return false;
  return fetch(`${host}/api/property/hotel/${id}/features/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function postHotelAddContact(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/add_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function postHotelEditContact(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/edit_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function HotelAddLandmark(id, payload) {
  //debugger
  return fetch(`${host}/api/property/hotel/${id}/add_landmark/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function postHotelAddRoomType(payload) {
  return fetch(`${host}/api/property/hotelroomtypes/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function postAddHotelRoomPhoto(payload) {
  const formData = new FormData();
  formData.append('photo', payload.photo);
  formData.append('hotel_room_type', payload.hotel_room_type)
  return fetch(`${host}/api/property/hotelroomphoto/`, {
    headers: getNonJsonHeaders(),
    method: 'POST',
    body: formData
  });

}

export function deleteRoomPhoto(id) {
  return fetch(`${host}/api/property/hotelroomphoto/${id}/`, {
    headers: getHeaders(),
    method: 'DELETE'
  });
}

export function fetchBrands() {
  return fetch(`${host}/api/brand/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchBrandGroups() {
  return fetch(`${host}/api/brandgroups/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function postHotelRemoveContact(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/remove_contact/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postHotelClaim(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/claim/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function fetchWaitlist() {
  return fetch(`${host}/api/property/wait_list/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function postWaitlist(payload) {
  return fetch(`${host}/api/property/wait_list/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function postPhotoSort(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/sort/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function patchPhoto(id, payload) {
  return fetch(`${host}/api/property/photo/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
export function uploadHotelImage(payload) {
  const formData = new FormData();
  formData.append('hotel', payload.hotel);
  if (payload.order) {
    formData.append('order', payload.order);
  }
  if (payload.name) {
    formData.append('name', payload.name);
  }
  formData.append('photo', payload.files[0]);
  return fetch(`${host}/api/property/photo/`, {
    method: 'POST',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}
export function uploadHotelDocument(id, payload) {
  const formData = new FormData();
  if(!payload.is_existing_url){
    formData.append('document', payload.document[0]);
  }
  if(payload.document_name) {
    formData.append('document_name', payload.document_name)
  }
  if(payload.existing_url) {
    formData.append('existing_url', payload.existing_url)
  }
  formData.append('is_existing_url', payload.is_existing_url);
  return fetch(`${host}/api/property/hotel/${id}/add_document/`, {
    method: 'POST',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}
export function updateDocument(id, payload) {
  const formData = new FormData();
  if(!payload.document_option){
     if(payload.document) {
        formData.append('document', payload.document[0]);
      }
  }
  if(payload.document_name) {
    formData.append('document_name', payload.document_name)
  }
  if(payload.existing_url) {
    formData.append('existing_url', payload.existing_url)
  }
  if(payload.id) {
    formData.append('document_id', payload.id)
  }
  formData.append('is_existing_url', payload.document_option);
  return fetch(`${host}/api/property/hotel/${id}/update_document/`, {
    method: 'POST',
    headers: getNonJsonHeaders(),
    body: formData,
  });
}
export function removeHotelDocument(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/delete_document/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
export function deleteHotelPhoto(id) {
  return fetch(`${host}/api/property/photo/${id}/`, {
    headers: getHeaders(),
    method: 'DELETE',
  });
}

// export function deleteRoomPhoto(id) {
//   return fetch(`${host}/api/property/hotel/${id}/remove_roomphoto/`, {
//     headers: getHeaders(),
//     method: 'POST',
//     body: JSON.stringify(id),
//   });
// }


export function deleteRoomType(id) {
  return fetch(`${host}/api/property/hotelroomtypes/${id}/`, {
    headers: getHeaders(),
    method: 'DELETE',
  });
}

export function patchRoomDesc(id, payload) {
  return fetch(`${host}/api/property/hotelroomtypes/${id}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}
export function patchLandmark(id, payload) {
  return fetch(`${host}/api/property/hotel/${id}/update_landmark/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function deleteLandmark(id) {
  return fetch(`${host}/api/property/hotel/${id}/remove_landmark/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(id),
  });
}


// WEBPACK FOOTER //
// src/routes/hotels/modules/api.js